import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSecureConfigStore } from 'state/store/config/useConfigStore';

interface SubscriptionRouteGuardProps {
    children: React.ReactNode;
}

/**
 * Route guard component that blocks access to subscription-related routes
 * when showSubscriptionInfo is false or undefined in site configuration settings.
 * 
 * Blocked routes:
 * - /subscription
 * - /checkout
 * 
 * When access is blocked, users are redirected to /chat
 */
export const SubscriptionRouteGuard: React.FC<SubscriptionRouteGuardProps> = ({ children }) => {
    const { siteConfigurationSettings } = useSecureConfigStore();
    const location = useLocation();

    // List of subscription-related routes that should be blocked
    // const blockedRoutes = ['/subscription', '/checkout'];
    const blockedRoutes: string[] = [];

    // Check if current route should be blocked
    const isBlockedRoute = blockedRoutes.some(route =>
        location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    // If showSubscriptionInfo is false or undefined and user is trying to access a blocked route
    if (!siteConfigurationSettings?.siteConfigurations?.data?.showSubscriptionInfo && isBlockedRoute) {
        // Redirect to chat page
        return <Navigate to="/chat" replace />;
    }

    // Allow access to the route/
    return <>{children}</>;
};
